import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import { useSiteMetadata } from '../hooks/use-site-metadata'
import { Navbar, Button, Nav } from 'react-bootstrap'
import Logo from './Logo.js'

const activeLinkStyle = {
  color: '#28a745',
}

const Header = () => {
  const { menuLinks } = useSiteMetadata()
  return (
    <header>
      <Navbar fixed="top" collapseOnSelect expand="sm" variant="light" bg="light">
        <Navbar.Brand>
          <Link to="/" className="navbar-brand d-flex">
            <Logo />
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
          <Nav className="justify-content-center">
            {menuLinks.map(link => (
              <Navbar.Text key={link.name} className="nav-item g-mx-10--md g-mx-10--lg g-mx-12--xl">

                <Link to={link.slug} activeStyle={activeLinkStyle} className="nav-link g-mx-10--lg g-mx-15--xl">
                  {link.name}
                </Link>

              </Navbar.Text>
            ))}
            <Navbar.Text className="g-mx-10--md g-mx-10--lg g-mx-12--xl">
              <Button><Link to="/signup" style={{color: "white", fontWeight: "bold"}}>Sign Up</Link></Button>
            </Navbar.Text>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

export default Header